import React, { Component } from 'react';
import { DataTableRowClickEventParams } from 'primereact/datatable';
import { ConfirmPopup } from 'primereact/confirmpopup';
import CustomTable, { CustomColumnProps } from 'components/custom/CustomTable';
import { CaseSettings } from '../../../domain/case/CaseDomains';
import DomainConfigurationService from '../../../service/DomainConfigurationService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import LanguageUtil from '../../../util/LanguageUtil';
import RoleHelper from '../../../RoleHelper';
import FolderView from '../../folder/view/FolderView';
import ListDraggableItem from '../../custom/ListDraggableItem';
import { dispatch, RootState } from '../../../redux/store';
import { ComponentState, setSelectedItems } from '../../../redux/actions/ComponentActions';
import { connect, ConnectedProps } from 'react-redux';
import EmptyComponent from '../../custom/empty-components/EmptyComponent';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import Icon from '../../../icons/Icon';
import { query } from '@trlogic/client-js';
import ComponentName from '../../../constant/ComponentName';
import CustomTableContentWrapper from '../../custom/CustomTableContentWrapper';
import ComponentUtil from '../../../util/ComponentUtil';
import moment from 'moment/moment';
import Order = query.Order;

class DomainConfigurationListViewerComponent extends Component<Props, State> {
  public state: State = new State();
  private domainConfigurationService: DomainConfigurationService = ServiceContainer.getInstance().get(ServiceNames.DOMAIN_CONFIGURATION);

  public render() {
    const {
      domains,
      views,
      component: { selectedComponentIds },
      onSortChange,
    } = this.props;
    return views && views.length > 0 && domains && domains.length > 0 ? (
      <div className={'overflow-y-scroll max-h-[calc(100dvh-430px)] scrollable-editor-container 2xl:max-h-[calc(100dvh-460px)] flex w-full  rounded-lg'}>
        <ConfirmPopup />
        <CustomTable
          value={domains}
          selectionMode='checkbox'
          selection={selectedComponentIds}
          onSelectionChange={this.onSelectionChange}
          componentName={ComponentName.CONFIGURATION}
          openNewTab={true}
          rowClassName={(data) => {
            const view = views.find((v: FolderView) => v.getModel().value?.payload.name == data.name);
            return view ? `list_${view?.getModel().id}` : '';
          }}
          onRowClick={this.openEditor}
          columns={this.getColumns()}
          onSortChange={onSortChange}
        />
        <ListDraggableItem itemType={ComponentName.CONFIGURATION} currentModal={this.props.currentModal} />
      </div>
    ) : (
      <EmptyComponent type={ComponentName.CONFIGURATION} />
    );
  }

  public componentDidMount() {
    const { domains } = this.props;
    this.setState({ domains, loading: false });
  }

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  };

  private openEditor = (e: DataTableRowClickEventParams) => {
    const { openEvent } = this.props;
    const name = e.data.name;
    openEvent(name);
  };

  private getColumns = (): CustomColumnProps[] => {
    const columns: CustomColumnProps[] = [
      {
        field: 'name',
        header: LanguageUtil.get({ id: 'pages.configuration.list.table.name', defaultMessage: 'Name' }),
        className: 'min-w-[20%]',
        copyable: true,
        onCopy: (e: CaseSettings) => {
          return e.name;
        },
        body: (record: CaseSettings) => {
          const { views } = this.props;
          const view: FolderView = views.find((view: FolderView) => view.getModel().value?.payload.name == record.name);
          return (
            <div className={'text-xs 2xl:text-md'}>
              <div id={`list_${view?.getModel().id}`} />
              <CustomTableContentWrapper clipSize={35} text={record.name} />
            </div>
          );
        },
      },
      {
        field: 'description',
        header: LanguageUtil.get({ id: 'pages.configuration.list.table.description', defaultMessage: 'Description' }),
        className: 'min-w-[320px]',
        sortable: true,
        body: (record: CaseSettings) => {
          return (
            <div className={'flex w-full items-start text-f-black-3 text-xs 2xl:text-md justify-start relative group'}>
              <CustomTableContentWrapper
                clipSize={52}
                text={
                  record.description ||
                  LanguageUtil.get({
                    id: 'pages.configuration.list.table.noDescription',
                    defaultMessage: 'This configuration does not have a descripiton yet.',
                  })
                }
              />
            </div>
          );
        },
      },
      {
        field: 'dataSource',
        header: LanguageUtil.get({ id: `common.label.transaction`, defaultMessage: 'Transaction' }),
        className: 'w-1/6',
        sortable: true,
        body: (record: CaseSettings) => {
          return (
            <div className={'text-left text-xs 2xl:text-md flex items-center'}>
              <CustomTableContentWrapper text={record.dataSource} />
            </div>
          );
        },
      },
      {
        field: 'createdAt',
        header: LanguageUtil.get({ id: 'pages.configuration.list.table.createdAt', defaultMessage: 'Created At' }),
        className: 'w-1/6',
        body: (record: CaseSettings) => {
          return (
            <div className={'flex w-full items-start text-f-black-3 text-xs 2xl:text-md justify-start relative group'}>
              <CustomTableContentWrapper text={record.createdAt ? moment(record.createdAt).format('LLL') : ''} />
            </div>
          );
        },
      },
      {
        field: 'updatedAt',
        header: LanguageUtil.get({ id: 'pages.configuration.list.table.updatedAt', defaultMessage: 'Update At' }),
        className: 'w-1/6',
        body: (record: CaseSettings) => {
          return (
            <div className={'flex w-full items-start text-f-black-3 text-xs 2xl:text-md justify-start relative group'}>
              <CustomTableContentWrapper text={record.updatedAt ? moment(record.updatedAt).format('LLL') : ''} />
            </div>
          );
        },
      },
      {
        field: 'action',
        header: LanguageUtil.get({ id: 'pages.configuration.list.table.action', defaultMessage: 'Action' }),
        className:'max-w-[60px] 2xl:max-w-[100px]',
        sortable: false,
        body: (record: CaseSettings) => {
          const isLocked = ComponentUtil.isLocked(ComponentName.CONFIGURATION, record.name);
          if (isLocked) {
            return null;
          }
          return (
            <div className={'flex w-full justify-start items-center gap-x-4'}>
              <div
                onClick={(e: any) => {
                  e.stopPropagation();
                  e.preventDefault();
                  customConfirm({
                    target: e.currentTarget,
                    accept: async () => await this.domainConfigurationService.removeDomainConfiguration(record.name),
                    message: LanguageUtil.get({ id: 'messages.confirm.remove1', defaultMessage: 'Are you sure you want to remove?' }),
                  });
                }}
              >
                <Icon
                  icon={'delete'}
                  size={20}
                  color={'primary'}
                  className={'hover:text-primary text-[#607080]hover:cursor-pointer flex items-center justify-center'}
                />
              </div>
            </div>
          );
        },
      },
    ];

    return columns.filter((column) => {
      if (column.field === 'action') {
        return RoleHelper.canEdit('CaseConfiguration');
      }
      return true;
    });
  };
}

class State {
  domains: CaseSettings[] = [];
  loading: boolean = true;
}

interface Props extends ReduxProps {
  domains: CaseSettings[];
  openEvent: (id: string) => void;
  views: any;
  currentModal: any;
  onSortChange: (order: Order[]) => void;
}

const mapStateToProps = (state: RootState) => ({
  component: state.component as ComponentState,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(DomainConfigurationListViewerComponent);
